export const checkBoxOnlyStyle = theme => ({
  '&.MuiCheckbox-root': {
    backgroundColor: `${theme.tokens.ComponentCheckboxDefaultBg}`,
    height: '20px',
    width: '20px',
    cursor: 'pointer',
    borderRadius: '4px',
    padding: '4px',
    color: `${theme.tokens.ComponentCheckboxDefaultColor}`,
    border: `1px solid ${theme.tokens.ComponentCheckboxDefaultBorder}`,
    '&:hover': {
      backgroundColor: `${theme.tokens.ComponentCheckboxDefaultHoverBg}`
    },
    '&.Mui-checked': {
      backgroundColor: `${theme.tokens.ComponentCheckboxCheckedBg}`,
      borderRadius: '4px',
      height: '20px',
      width: '20px',
      strokeWidth: '2px',
      color: `${theme.tokens.ComponentCheckboxCheckedColor}`,
      borderColor: `${theme.tokens.ComponentCheckboxCheckedBg}`
    },
    '&.MuiCheckbox-indeterminate': {
      svg: {
        strokeWidth: '2px'
      }
    },
    '&.Mui-disabled': {
      borderColor: `${theme.tokens.ComponentCheckboxDisabledBorder}`,
      backgroundColor: `${theme.tokens.ComponentCheckboxDisabledBg}`,
      '&.Mui-checked, &.MuiCheckbox-indeterminate': {
        color: `${theme.tokens.ComponentCheckboxDisabledColor}`
      }
    }
  }
});